export default {
  computed: {
    allFieldsValidated() {
      let noEmpty = true;
      Object.keys(this.form).forEach((key) => {
        if (!this.form[key].isHidden
          && this.objectIsEmpty(this.form[key].values)) {
          noEmpty = false;
        }
      });
      return noEmpty;
    },
    hasNoError() {
      let noError = true;
      if (this.allFieldsValidated) {
        Object.keys(this.form).forEach((key) => {
          if (this.form[key].values.error) {
            noError = false;
          }
        });
      }
      return noError;
    },
    disableValidateButton() {
      return this.disableSubmit || (!this.hasNoError && !this.inputDetected);
    },
  },
  methods: {
    resetInputs() {
      this.$emit('reset-inputs');
    },
    resetForm() {
      // Sets all form values to {}
      this.form = this.setValuesInObject(this.form, {});
    },
    clickedValidate() {
      // On validate, we empty each input
      // which will be validated again and stored in the cleaned object
      this.resetForm();

      // Tell all children inputs to validate
      this.$emit('validate-fields');
    },
    onInput(values) {
      if (!!values) {
        this.form = this.setValuesInObject(this.form, values, values.label);
      }
      this.inputDetected = true;
      if (this.errorMsg && this.errorMsg !== '') {
        this.errorMsg = '';
      }
    },
    setValuesInObject(object, value, label) {
      // Make a copy of the received object to avoid reassigning to received parameter
      const modifiedObject = Object.assign({}, {}, object);

      // If key is received then we want to update only that one entry with value
      // Otherwise we want to update all entries with value
      Object.keys(modifiedObject).forEach((objectKey) => {
        if (!label || (!!label && modifiedObject[objectKey].label === label)) {
          modifiedObject[objectKey].values = value;
        }
      });
      return modifiedObject;
    },
    validate(values) {
      this.inputDetected = false;
      this.form = this.setValuesInObject(this.form, values, values.label);
      if (this.allFieldsValidated) {
        if (this.hasNoError && !this.disableSubmit) {
          // this.$modal.show('confirm-modal', {
          //   'question': 'Please confirm that you have listed that property.',
          //   'onconfirm': this.saveDetails
          // });
          this.saveDetails();
        }
      }
    },
    objectIsEmpty(obj) {
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          return false;
        }
      }
      return true;
    },
    getValueFromFormObject(object) {
      if (object && object.values && object.values.value) {
        return object.values.value;
      }
      return null;
    },
  },
};
